import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "rating flex flex-nowrap items-center w-full justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.51347 19.3034C4.03042 19.5517 3.48346 19.1178 3.58071 18.5634L4.61787 12.6516L0.214954 8.45578C-0.196522 8.06366 0.0164784 7.34671 0.567715 7.2684L6.69081 6.39856L9.42096 0.990381C9.66689 0.503206 10.3331 0.503206 10.579 0.990381L13.3092 6.39856L19.4323 7.2684C19.9835 7.34671 20.1965 8.06366 19.785 8.45578L15.3821 12.6516L16.4193 18.5634C16.5165 19.1178 15.9696 19.5517 15.4865 19.3034L10 16.4835L4.51347 19.3034Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
      return _createElementVNode("div", {
        key: i,
        class: _normalizeClass(["mr-1", i <= _ctx.number ? 'text-yellow-400' : 'text-neutral-200'])
      }, _hoisted_3, 2)
    }), 64))
  ]))
}